<template>
    <modal @close="closeFromModal">
        <h5 slot="header">Détails de la campagne</h5>
        <div slot="body">
            <show-campaign :campaign_id="campaign_id" />
        </div>
        <div slot="footer" class="d-flex w-100 justify-content-between">
            <button class="modal-default-button btn-sm btn btn-secondary btn-circle" @click="close">Fermer</button>
        </div>
    </modal>
</template>

<script>
import ShowCampaign from "../../../Admin/Campaigns/ShowCampaign";

export default {
    props: {
        campaign_id: {
            required: true,
        },
    },
    methods: {
        close() {
            this.$emit("close");
        },
        closeFromModal: function (e) {
            if (e && e.target && !e.target.classList.contains("modal-wrapper")) {
                e.stopPropagation();
            } else {
                this.close();
            }
        },
    },
    components: {
        ShowCampaign,
    },
};
</script>
